import { render } from "./ScienceTechnologyLoan.vue?vue&type=template&id=37b6b92b&scoped=true"
import script from "./ScienceTechnologyLoan.vue?vue&type=script&lang=js"
export * from "./ScienceTechnologyLoan.vue?vue&type=script&lang=js"

import "./ScienceTechnologyLoan.vue?vue&type=style&index=0&id=37b6b92b&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b6b92b"]])

export default __exports__